import { Module } from 'vuex';
import { NodeModelStoreModule, NodeModelStoreState } from '@/store/nodeModel';
import { LayerName } from '@etp/etp-pipelines-client/axios';
import { PipelinesStoreModule, PipelinesStoreState } from '@/store/pipelines';

const getDefaultState = () => {
  return {
    ...new NodeModelStoreModule('export').state,
    ...new PipelinesStoreModule(LayerName.ExportLayer).state
  };
};

interface ExportState extends NodeModelStoreState, PipelinesStoreState {}

const nodeModelStore = new NodeModelStoreModule('export');
const pipelinesStore = new PipelinesStoreModule(LayerName.ExportLayer);

class ExportModule implements Module<ExportState, any> {
  namespaced = true;
  state = {
    ...nodeModelStore.state,
    ...pipelinesStore.state
  };
  getters = {
    ...nodeModelStore.getters,
    ...pipelinesStore.getters
  };
  actions = {
    ...nodeModelStore.actions,
    ...pipelinesStore.actions
  };
  mutations = {
    ...nodeModelStore.mutations,
    ...pipelinesStore.mutations,
    RESET_STATE(state: ExportState) {
      Object.assign(state, getDefaultState());
    }
  };
}

export default new ExportModule();
